import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MessageBusService } from '../message-bus.service';
import { LoggerService } from '../logging/logger-factory.service';
import { PriceDataFeedBackendService } from './price-data-feed-backend-service.class';
import { PriceChartDataFeed } from './price-chart-data-feed';

@Injectable({ providedIn: 'root' })
export class PriceChartDataFeedFactoryService {

   constructor(
      private readonly _backend: PriceDataFeedBackendService,
      private readonly _messageBus: MessageBusService,
      private readonly _toastr: ToastrService,
      private readonly _loggerService: LoggerService
   ) {
   }

   getDataFeed(componentId: string): PriceChartDataFeed {
      const feed = new PriceChartDataFeed(
         componentId,
         this._backend,
         this._messageBus,
         this._toastr,
         this._loggerService
      );
      feed.init();
      return feed;
   }
}
